module.exports = __webpack_public_path__ + "static/media/STPProjectPrevieww935@1x.bb6800bf.webp";